<template>
	<b-card no-body class="mb-2">
		<b-card-header header-tag="header" class="p-0" role="tab">
			<div class="row">
				<div class="col-md-10">
					<div
						v-b-toggle="collapseCardId"
						class="accordeon-participant-pane"
					>
						#{{ personNumber }} Карточка участника
					</div>
				</div>
				<div class="col-md-2 float-right  align-self-center">
					<b-button size="sm" class="" variant="danger" @click="deletePerson(personNumber)">
						Удалить
					</b-button>
				</div>
			</div>
		</b-card-header>
		<b-collapse :id="collapseCardId" class visible role="tabpanel">
			<b-card-body>
				<b-form>
					<div v-if="formData.fields" class="row">
						<base-field
							v-for="field in formData.fields[getStep(formData.id)]"
							:key="field.form_field_id"
							ref="baseFields"
							:field="field"
							:person-number="personNumber"
							:form-data="formData"
							@blur="onBlur"
						/>
					</div>
				</b-form>
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<script>
import BaseField from '~/components/checkout/CheckoutBaseField.vue';
import { mapGetters } from 'vuex';
import checkoutFormStep from '@/mixins/checkoutFormStep';
import {
	ACTION_DELETE_PERSON,
	ACTION_GET_PRICE_DATA,
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_REMOVE_PERSON_DATA,
	MUTATION_SET_FORM_META_DATA,
} from '@/store/checkout';

export default {
	name: 'Step2PersonFieldGroup',
	components: { BaseField },
	mixins: [checkoutFormStep],
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			getStep: 'checkout/getStep',
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getIsRegistrant: 'checkout/getIsRegistrant',
		}),
		collapseCardId() {
			return `collapse-card_${this.personNumber}`;
		},
	},
	methods: {
		async deletePerson(personNumber) {
			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_DELETE_PERSON}`,
				{
					personNumber,
					formId: this.formData.id,
				},
			);

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_PRICE_DATA}`,
				{ formId: this.formData.id },
			);
		},
	},
};
</script>

<style scoped>
</style>
